import styled from "styled-components";
import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Wrapper = styled.div`
  width: 100%;
  padding: 13px;
  border-radius: ${theme.border.smallRadius};
  border: 1px solid #b9c1cb;
  max-height: 200px;
  overflow-y: auto;
`;

export const ListElement = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;

export const ListItem = styled.li`
  padding: 6px 0;
  font-size: ${theme.font.sizes.xxxsmall};
  font-family: ${theme.font.montserrat};
  color: ${theme.colors.gray100};
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }

  strong {
    color: ${theme.colors.primary};
  }
`;

export const EmptyMessage = styled.div`
  font-size: ${theme.font.sizes.xxsmall};
  font-family: ${theme.font.montserrat};
  color: ${theme.colors.gray300};
  font-style: italic;
`;
